window.VegasShop = {
	onToggleTools: function (method, $tool) {
		let $container = $('.vg-shop-tools'),
			$li = $tool ? $tool.closest('li') : null;

		if (method === 'toggle') {
			$container.find('.current').removeClass('current');
			if ($li) $li.addClass('current');

			if ($container.hasClass('show') && $tool.hasClass('active')) {
				$container.removeClass('show');
				$tool.removeClass('active');
			} else if ($container.hasClass('show') && !$tool.hasClass('active')) {
				$tool.closest('ul').find('.active').removeClass('active');
				$tool.addClass('active');
			} else {
				$container.addClass('show');
				$tool.addClass('active');
			}

			let panel = $tool.data('tool'),
				route = $tool.data('route');

			if ($container.hasClass('show')) {
				$container.find('[data-panel]').hide();
				$container.find('[data-panel=' + panel + ']').show();

				request(route, '#vg-shop-tools--panel-' + panel, panel);
			}
		}

		if (method === 'dispose') {
			$container.find('.active').removeClass('active');
			$container.removeClass('show');
		}

		function request(route, target, panel) {
			let param = {
				_token: App.csrf,
			};

			let $preloader = $(target).find('.vg-loader-preload'),
				$emptyCart = $(target).find('.vg-shop-tools--empty'),
				$productsWrapper = $(target).find('.vg-shop-tools--products');

			$preloader.fadeIn();
			$emptyCart.hide();
			$productsWrapper.hide();

			$.get(route, param, function (data) {
				if (!data.error) {
					$preloader.fadeOut();

					if ('sums' in data && 'sum_products' in data.sums) {
						$container.find('[data-cart][data-counter="sum-products"]')
							.text(output_money(data.sums.sum_products));
					}

					if (data.products.length) {
						$productsWrapper.show();

						eachProducts(data.products, $productsWrapper.find('.products-wrapper'), panel);

						$container.find('[data-toggle=tooltip]').tooltip();
					} else {
						$emptyCart.fadeIn();
					}
				}
			});
		}

		function eachProducts(products, $target, panel) {
			$target.find('.vg-shop-prd').remove();

			for (let i = 0; i <= products.length - 1; i++) {
				let $prd = $('.vg-shop-prd.clone-prd').clone().removeClass('clone-prd').addClass('cart-prd');
				$target.append($prd);
				if (panel === 'cart' && ('inFav' in products[i] && products[i].inFav)) {
					$prd.addClass('in-fav');
					$prd.find('.prd-addCart').remove();
				} else if (panel === 'fav') {
					$prd.find('.prd-fav').remove();
					$prd.find('.prd-addCart').show();
					$prd.find('.prd-total').remove();
					$prd.find('.prd-count').remove();
					$prd.find('.prd-remove a').attr('title', 'Убрать из избранных');
					$prd.find('.prd-remove a').removeAttr('data-cart');
					$prd.find('.prd-remove a').attr('data-fav', true);
				}

				if ('inCart' in products[i] && products[i].inCart) {
					$prd.find('.btn').removeClass('btn--outline-primary').addClass('btn--primary')
				}

				$prd.attr('data-id', products[i].id);
				$prd.attr('data-pivot_id', products[i].pivot_id);
				$prd.find('img').attr('src', products[i].img);
				$prd.find('.title').text(products[i].title);
				$prd.find('.price').text(output_money(products[i].price));
				$prd.find('.title').attr('href', products[i].link);
				$prd.find('.total input').val(products[i].cnt);
				$prd.find('.price-total').html(output_money(products[i].price_total));
			}
		}
	}
};

/**
 * Events
 **/
$(document).ready(function () {
	$(document).on('click', '[data-toggle=vg-shop-tools]', function () {
		VegasShop.onToggleTools('toggle', $(this))

		return false;
	});

	$(document).mouseup(function (e) {
		let $container = $('.vg-shop-tools, [data-toggle=vg-shop-tools]');

		if ($container.has(e.target).length === 0) {
			VegasShop.onToggleTools('dispose', false);
		}
	});

	$(document).on('click', '[data-dismiss=vg-shop-tools]', function () {
		VegasShop.onToggleTools('dispose', false);

		return false;
	});

	$(document).on('click', '.vg-shop-tools--panel [data-cart=change-items]', function () {
		let $self = $(this),
			$container = $self.closest('.vg-shop-prd'),
			$input = $container.find('input[name=cnt]'),
			sign = $self.data('sign'),
			cnt = $input.val() || 1;

		if (sign === 'minus') {
			if (cnt > 1) cnt--;
		} else {
			cnt++;
		}

		$input.val(cnt);

		let $cartPrd = $(this).closest('.cart-prd');

		VegasShop.Cart.requestChange({
			pivot_id: $cartPrd.data('pivot_id'),
			cnt: cnt,
			get_all_sums: true,
			get_products_totals: true,
		}, {
			afterSend: function (data) {
				VegasShop.Cart.total(data);
			}
		});

		return false;
	});



	$(document).on('click', '.vg-shop-tools--panel [data-cart][data-action="del"]', function () {
		let $prd = $(this).closest('.vg-shop-prd');
		let $panel = $(this).closest('[data-panel="cart"]');

		VegasShop.Cart.requestDel({
			pivot_id: $prd.data('pivot_id')
		}, {
			beforeSend: function () {
				$prd.find('[data-toggle=tooltip]').tooltip('dispose');
				$prd.remove();
				let productsExists = $panel.find('.cart-prd').length > 0;

				if (!productsExists) {
					$panel.find('.vg-shop-tools--products').hide();
					$panel.find('.vg-shop-tools--empty').show();
				}
			}
		});

		return false;
	});

	$(document).on('click', '.vg-shop-tools--panel [data-fav][data-action="del"]', function () {
		let $prd = $(this).closest('.vg-shop-prd');
		let $panel = $(this).closest('[data-panel="fav"]');

		VegasShop.Fav.del($prd);

		return false;
	});

	$(document).on('click', '.tabs .tab', function () {
		let code = $(this).attr('data-tab');
		console.log($('.tabs-content .t-content'));
		$('.tabs-content .t-content').removeClass('active');
		$('.tabs .tab').removeClass('active');
		$('.tabs-content .t-content[data-tab='+code+']').addClass('active');
		$(this).addClass('active');
	});
	let swiper = new Swiper('.gs-init', {
		direction: 'horizontal',
		loop: false,
		slidesPerView: 1,
		spaceBetween: 20,
		navigation: {
			nextEl: '.gifts-navigation.arrow-next',
			prevEl: '.gifts-navigation.arrow-prev'
		},
		breakpoints: {
			768: {
				direction: 'horizontal',
				slidesPerView: 2,
				spaceBetween: 25,
			},
			991: {
				slidesPerView: 4,
				spaceBetween: 20,
				direction: 'vertical',
			},
			1200: {
				slidesPerView: 1,
				spaceBetween: 20,
				direction: 'horizontal',
			},
			1500: {
				slidesPerView: 4,
				spaceBetween: 15,
				direction: 'vertical',
			}
		}
	});
	$(document).on('click', '.restyle .quantity [data-cart=change-items]', function () {
		let $self = $(this),
			$cartPrd = $(this).closest('.restyle .quantity'),
			$input = $cartPrd.find('input[name=cnt]'),
			sign = $self.data('sign'),
			cnt = $input.val() || 1;

		if (sign === 'minus') {
			if (cnt > 1) cnt--;
		} else {
			cnt++;
		}

		$input.val(cnt);
	});
});
